/**
 * This module listen for variables status update
 */

import { validator } from './schema';
import { executor } from './executor';

// export default [validator];
export default [validator, executor];
